<template>
    <div>
        <my-table :title="title"
                  :isAdd="isAdd"
                  :searchParams="searchParams"
                  :tableData="tableData"
                  @pageNumChange="pageNumChange"
                  @search="search"
                  @keyup.enter.native="keyup()" @add="addCollector">>
            <div slot="table">
                <collector-table :tableData="tableData.list" @update="update" @view="view" @del="del"></collector-table>
            </div>
        </my-table>
    </div>
</template>

<script>
    import CollectorTable from "./CollectorTable";
    import MyTable from "../../components/content/myTable/MyTable";
    import {delByCollectionId, getCollectionBySearch, newVue} from "../../network/collector";

    export default {
        name: "CollectorList",
        components: {CollectorTable, MyTable},
        data(){
            return {
                title: "采集商列表",
                isAdd: true,
                tableData:{},
                searchItems:{},
                searchParams:[
                    {
                        key:"name",
                        value:"采集商名称"
                    },
                    {
                        key:"phone",
                        value:"手机号码"
                    },
                ],
            }
        },
        created() {
            newVue.obj = this;
            this.common.HeaderLocationTwo.href =  "/collector/list";
            this.common.HeaderLocationTwo.name = "采集管理"
            this.common.HeaderLocationThree.name = "采集商列表"
        },
        activated(){
            this.refresh();
        },

        methods:{
            keyup(){
                this.searchEasy(this.searchItems);
            },
            search(searchItems){
                this.searchItems = searchItems;
                this.searchEasy(searchItems)
            },
            pageNumChange(pageNum){
                this.searchEasy(this.searchItems,pageNum);
            },
            searchEasy(searchItems,pageNum){
                let Name = null;
                let Phone = null;
                for (let i = 0;i<searchItems.length;i++){
                    if (searchItems[i].value === "name"){
                        Name = searchItems[i].input
                    }else if (searchItems[i].value === "phone"){
                        Phone = searchItems[i].input
                    }
                }
                getCollectionBySearch(pageNum,10,Name,Phone).then(res => {
                    this.tableData = res.data
                })
            },
            addCollector(){
                this.$router.push("insert/")
            },
            view(id){
                this.$router.push("/collector/detail/"+id);
            },
            //删除
            del(id){
                this.$confirm('此操作将永久删除该采集商以及相关订单, 是否继续?', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                    delByCollectionId(id).then(res => {
                            this.refresh();
                        }
                    )
                }).catch(() => {
                    this.$message({
                        type: 'info',
                        message: '已取消删除'
                    });
                });
            },
            //修改
            update(id){
                this.$router.push("insert/"+id)
            },
            refresh(){
                getCollectionBySearch(1,10,null,null).then(res => {
                    this.tableData = res.data;
                })
            }
        }
    }
</script>

<style scoped>

</style>
